import HttpResponse from "../../../../../utils/http/http.response";

export enum CargoCompanyOrderBillingsListResponseDataItemBillingType {
  PUB_CARGO_2_RAILY = "PUB_CARGO_2_RAILY",
  PRIV_CARGO_2_TAXI = "PRIV_CARGO_2_TAXI",
}

export type CargoCompanyOrderBillingsListResponseDataItemBillingNodes = {
  description: string;
};

export type CargoCompanyOrderBillingsListResponseDataItem = {
  id: string;
  date: string;
  humanId: string;
  status: string;
  distance: number;
  amountForDistance: number;
  baseDistanceRate: number;
  amountForChargeHaltings: number;
  hoursOfHaltings: number;
  amountForChargeHighways: number;
  allContributionsAmount: number;
  contractCorrectionPercentage: number;
  sumOfDiscounts: number;
  billingType: CargoCompanyOrderBillingsListResponseDataItemBillingType;
  taxiCorporation: string;
  dispatch: string;
  externalId: string;
  billingNodes: CargoCompanyOrderBillingsListResponseDataItemBillingNodes[];
  passengers: string[];
};

export type CargoCompanyOrderBillingsListResponseData = {
  data: CargoCompanyOrderBillingsListResponseDataItem[];
  totalCount: number;
};

type CargoCompanyOrderBillingsListResponse =
  HttpResponse<CargoCompanyOrderBillingsListResponseData>;

export default CargoCompanyOrderBillingsListResponse;
